(function(app) {

    app.provider("marketplaceApi",
    [
        function() {
            this.$get = [
                "portalApiGateway", function(portalApiGateway) {
                    var service = {};

                    service.getToken = function() {
                        return portalApiGateway.get("/Marketplace/Token");
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app);